import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  DateInput,
  FileInput,
  FileField,
  useRedirect,
} from "react-admin";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { uploadProofFile } from "../firebase/uploadHelper";

// 🔹 Dropdown options for payment type
const paymentOptions = [
  { id: "Al Masraf Bank", name: "Al Masraf Bank" },
  { id: "Bank Visa Card", name: "Bank Visa Card" },
  { id: "Cash in Office", name: "Cash in Office" },
  { id: "Noqodi Wallet", name: "Noqodi Wallet" },
  { id: "Adcb Bank", name: "Adcb Bank" },
];

export const UpcomingExpensesCreate = () => {
  const redirect = useRedirect();

  const handleSave = async (values) => {
    try {
      const file = values.document?.rawFile;
      let proofUrl = "";

      // 🔹 Upload proof document if present
      if (file) {
        proofUrl = await uploadProofFile(file, "upcomingExpenses");
      }

      // 🔹 Prepare Firestore document data
      const newExpense = {
        title: values.title || "",
        amount: Number(values.amount) || 0,
        remarks: values.remarks || values.description || "",
        plannedDate: values.plannedDate || values.date || "", // ✅ unified field name
        paymentType: values.paymentType || "",
        proofUrl,
        status: "pending",
        createdBy: localStorage.getItem("email") || "",
        createdAt: serverTimestamp(),
      };

      // 🔹 Save to Firestore
      await addDoc(collection(db, "upcomingExpenses"), newExpense);

      alert("✅ Upcoming expense created successfully!");
      redirect("list", "upcomingExpenses");
    } catch (err) {
      console.error("❌ Error saving expense:", err);
      alert("❌ Error saving: " + err.message);
    }
  };

  return (
    <Create title="Add Upcoming Expense">
      <SimpleForm onSubmit={handleSave}>
        <TextInput source="title" label="Expense Title" fullWidth required />

        <NumberInput source="amount" label="Amount (AED)" fullWidth required />

        <TextInput
          source="remarks"
          label="Remarks / Description"
          multiline
          fullWidth
        />

        {/* ✅ Use consistent field name 'plannedDate' */}
        <DateInput source="plannedDate" label="Planned Expense Date" required />

        <SelectInput
          source="paymentType"
          label="Payment Type"
          choices={paymentOptions}
          required
        />

        <FileInput
          source="document"
          label="Upload Proof Document (optional)"
          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
        >
          <FileField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
};
